module.exports = __webpack_public_path__ + "static/media/electromovilidad transporte publico rm.dfe4c2d4.jpg";